import React from 'react';
import { NumericTextBox } from "@progress/kendo-react-inputs";

function DecimalEditor(props) {

    if (typeof(props.id) != 'string') {
        throw new TypeError("Required ID prop has not been set")
    }

    const onEditorChange = (e) => {

        if (props.onChange) {
            props.onChange({ originalEvent: e, value: e.target.value, props: props });
        }
    }

    return (
        (props.naked ?
            <NumericTextBox
                tabIndex={props.tabIndex}
                value={props.value}
                format={props.format}
                spinners={props.spinners}
                onChange={onEditorChange}
                min={props.min}           
                />
            :
        <td className={props.className || "control"} colSpan={props.colSpan}>
            <NumericTextBox
                tabIndex={props.tabIndex}
                value={props.value}
                format={props.format}
                spinners={props.spinners}
                onChange={onEditorChange}
                min={props.min}           
                />
        </td>
        )
    )
}

export default DecimalEditor;